import { MIDWIVES, USERS } from '../collections/names'
import {
  type TemplateCollectionId,
  type TemplateKey,
  type TemplateKeyToCollectionId,
} from '../types/templates'

export const templateCollectionToDocumentType: Record<TemplateCollectionId, TemplateKey> = {
  authAppealsTemplates: 'authAppeals',
  authInstructionsTemplates: 'authInstructions',
  authTemplates: 'authorizations',
  invoicesReceiptsTemplates: 'invoiceAndReceipt',
  claimTemplates: 'claims',
  clinicalsTemplates: 'clinicals',
  templates: 'assessments',
  consentFormTemplates: 'consentForm',
  practiceContractTemplates: 'practiceContract',
}

export const templateTypeNames: Record<TemplateKey, string> = {
  authAppeals: 'auth appeal',
  consentForm: 'consent form',
  authorizations: 'authorization',
  authInstructions: 'auth instruction',
  invoiceAndReceipt: 'invoices / receipt',
  claims: 'claims',
  clinicals: 'clinical',
  assessments: 'assessment',
  practiceContract: 'practice contract',
}

export const templateCollectionToName: Record<TemplateCollectionId, string> = {
  authTemplates: templateTypeNames.authorizations,
  consentFormTemplates: templateTypeNames.consentForm,
  authAppealsTemplates: templateTypeNames.authAppeals,
  authInstructionsTemplates: templateTypeNames.authInstructions,
  invoicesReceiptsTemplates: templateTypeNames.invoiceAndReceipt,
  claimTemplates: templateTypeNames.claims,
  clinicalsTemplates: templateTypeNames.clinicals,
  templates: templateTypeNames.assessments,
  practiceContractTemplates: templateTypeNames.practiceContract,
}

export const templateKeyToCollection: {
  [Key in TemplateKey]: TemplateKeyToCollectionId[Key]
} = {
  authAppeals: 'authAppealsTemplates',
  consentForm: 'consentFormTemplates',
  authInstructions: 'authInstructionsTemplates',
  authorizations: 'authTemplates',
  invoiceAndReceipt: 'invoicesReceiptsTemplates',
  claims: 'claimTemplates',
  clinicals: 'clinicalsTemplates',
  assessments: 'templates',
  practiceContract: 'practiceContractTemplates',
}

export const getTemplateCollectionPath = (practiceId: string | null, templateType: TemplateKey) => {
  if (practiceId) {
    switch (templateType) {
      case 'consentForm':
        return `${MIDWIVES}/${practiceId}/consent-forms`
      default:
        throw new Error(`Invalid template type for practices: ${templateType}`)
    }
  }
  return templateKeyToCollection[templateType]
}

const documentTypes: TemplateKey[] = [
  'authAppeals',
  'authInstructions',
  'invoiceAndReceipt',
  'claims',
]
export const isDocumentType = (templateKey: TemplateKey): boolean =>
  documentTypes.includes(templateKey)

export const getAdminTemplateCollectionPath = (templateKey: TemplateKey): string =>
  templateKeyToCollection[templateKey]

export const getAdminTemplatePath = (templateKey: TemplateKey, templateId: string): string =>
  `${getAdminTemplateCollectionPath(templateKey)}/${templateId}`

export const getDocumentSentPdfPath = (
  patientId: string,
  templateType: TemplateKey,
  now: string,
): string => `${USERS}/${patientId}/${templateType}/${now}-sent.pdf`

export const getDocumentSignedPdfPath = (
  patientId: string,
  templateType: TemplateKey,
  sentOn: string,
): string => `${USERS}/${patientId}/${templateType}/${sentOn}-signed.pdf`
